import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from '@/router'
import plugins from './plugins'
import { createPinia } from 'pinia'
import i18n from '@/i18n'
import '@/assets/icons/index'

import '@/styles/index.scss'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

const app = createApp(App)
const pinia = createPinia()

for (let [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app
  .use(router)
  .use(pinia)
  .use(plugins)
  .use(i18n)
  .use(ElementPlus, {
    size: 'default'
  })
  .mount('#app')
